import { useState } from "react"
import { StackView, Dropdown, Box, Text } from "@planningcenter/tapestry-react"
import { PropTypes } from "prop-types"
import SelectionTypesOptionsModal from "./SelectionTypesOptionsModal"
import { ModalTrigger, useModal } from "../modals/Modal"

const OptionsDropdown = ({
  signup,
  onSaveClick,
  signupTimes: signupTimesFromProps,
  registerForSeparateTimesEnabled,
  canChangeRegisterForSeparateTimes
}) => {
  const [maxAttendees, setMaxAttendees] = useState(signup.maximumRegistrationAttendees || "")
  const [signupTimes, setSignupTimes] = useState(signupTimesFromProps)
  const [enableSplitRegistrations, setEnableSplitRegistrations] = useState(
    registerForSeparateTimesEnabled
  )
  const { onModalClose, onSaving } = useModal()

  const isSimple = signup.registrationType == "simple"

  const handleSaveClick = () => {
    onSaving()
    const optionsToSave = []

    const maxRegAttendees = maxAttendees === "" ? null : maxAttendees
    if (maxRegAttendees !== signup.maximumRegistrationAttendees) {
      optionsToSave.push({ type: "maxAttendees", value: maxAttendees })
    }

    if (enableSplitRegistrations !== registerForSeparateTimesEnabled) {
      optionsToSave.push({ type: "enableSplitReg", value: enableSplitRegistrations })
    }

    if (enableSplitRegistrations) {
      signupTimes.forEach((time, idx) => {
        if (
          time.availableForRegistrations !== signupTimesFromProps[idx].availableForRegistrations
        ) {
          optionsToSave.push({ type: "availableForReg", value: time })
        }
      })
    }

    onSaveClick(optionsToSave)
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        onModalClose()
      })
  }

  const resetSignupTimes = () => {
    setSignupTimes(signupTimesFromProps)
  }

  const handleCancel = () => {
    setMaxAttendees(signup.maximumRegistrationAttendees)
    onModalClose()
  }

  const renderAvailableTimesText = times => {
    const availableTimes = times.filter(time => time.availableForRegistrations).length
    return `${availableTimes} ${
      availableTimes > 1 ? "dates are" : "date is"
    } available for registration`
  }

  return (
    <>
      <SelectionTypesOptionsModal
        maxAttendees={maxAttendees}
        setMaxAttendees={setMaxAttendees}
        isSimple={isSimple}
        signupTimes={signupTimes}
        setSignupTimes={setSignupTimes}
        resetSignupTimes={resetSignupTimes}
        enableSplitRegistrations={enableSplitRegistrations}
        canChangeRegisterForSeparateTimes={canChangeRegisterForSeparateTimes}
        setEnableSplitRegistrations={setEnableSplitRegistrations}
        handleSaveClick={handleSaveClick}
        handleCancel={handleCancel}
        generalRemindersEnabled={signup.generalRemindersEnabled}
      />

      <Dropdown variant="outline" title="Options">
        <StackView padding={2}>
          <Box marginBottom={3}>
            <Text weight={700} size="14px" marginBottom={0.5}>
              Maximum selections per registration
            </Text>
            <Text>{signup.maximumRegistrationAttendees || "Unlimited"}</Text>
          </Box>
          {isSimple && (
            <Box marginBottom={3}>
              <Text weight={700} size="14px" marginBottom={0.5}>
                Split registrations
              </Text>
              {registerForSeparateTimesEnabled ? (
                <Text>{renderAvailableTimesText(signupTimes)}</Text>
              ) : (
                <Text>Not Enabled</Text>
              )}
            </Box>
          )}
          <Box>
            <ModalTrigger title="Manage" className="btn-outline sm" />
          </Box>
        </StackView>
      </Dropdown>
    </>
  )
}

OptionsDropdown.propTypes = {
  signup: PropTypes.object,
  onSaveClick: PropTypes.func,
  status: PropTypes.shape({
    text: PropTypes.string,
    icon: PropTypes.string,
    type: PropTypes.string
  }),
  signupTimes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      availableForRegistrations: PropTypes.bool
    })
  ),
  registerForSeparateTimesEnabled: PropTypes.bool,
  canChangeRegisterForSeparateTimes: PropTypes.bool
}

export default OptionsDropdown
